export enum LiveChatType {
  SALES_IQ = "SALES_IQ",
  ROCKET = "ROCKET",
}
